import { Doc } from '../pages/Doc';
import Users from '../pages/User/Users';
import Histories from '../pages/Histories';
import Dashboard from '../pages/Dashboard';
import MyAccount from '../pages/User/MyAccount';
import MyCompany from '../pages/Company/MyCompany';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CreateOrUpdateUser from '../pages/User/CreateOrUpdateUser';
import StatisticsScreen from '../pages/StatisticsScreen';
import NavBar from '../components/NavBar';
import CurveLevelingGraphic from '../pages/SearchEngines/Curve_leveling_graphic';
import TableFull from '../pages/TableFull';
import { useAuth } from '../hooks/useAuth';

export default function RepresentativeRoutes(): JSX.Element {
  const { content } = useAuth()

  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path="*" element={<Dashboard />} />
        <Route path="/" element={<Dashboard />} />
        <Route path="/company/:id" element={<MyCompany />} />
        <Route path="/users/company/:id" element={<Users />} />
        <Route path="/user/:id" element={<CreateOrUpdateUser />} />
        <Route path="/new-user" element={<CreateOrUpdateUser />} />
        <Route path="/histories" element={<Histories />} />
        <Route path="/my-account/:id" element={<MyAccount />} />
        <Route path="/doc" element={<Doc />} />
        {(content?.is_admin || content?.is_representative) && (
          <Route path="/statistics" element={<StatisticsScreen />} />
        )}
        <Route
          path="/curve_leveling_graphic"
          element={<CurveLevelingGraphic />}
        />
        {
          content?.company && content?.can_download_full_table && (
            <Route
              path="/download-full"
              element={<TableFull />}
            />
          )
        }
      </Routes>
    </BrowserRouter>
  );
}
